import styled from "styled-components";
//components
import Text from "components/Text";
import { Row } from "components/Layout/Grid";

export const Container = styled.div``

export const TitleListContainer = styled.div`
  width: 100%;
  height: 300px;

  padding: 16px 24px 16px 32px;

  overflow-y: auto;
  background-color: #F2F2F2;
`

export const TitleItemText = styled(Text)`
  font-size: 16px;
  font-weight: 900;
`

export const TitleItemSubtitle = styled(Text)`
  font-weight: 400;
`

export const TitleItemSubtitleRow = styled(Row)`
  display: flex;
  justify-content: space-between;
`

export const TitleItemValue = styled(Text)`
  font-weight: 400;
`